export default __webpack_public_path__ + "static/media/tempo-midup.b7ce7cb5.svg";